import React from "react";
import "./Nav.css";
import NavBarLogoFinal from "../../media/NavBarLogoFinal.svg";
import { Nav } from "react-bootstrap";

interface ReferenceNavProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  handleLogout: () => void;
}

const ReferenceNav: React.FC<ReferenceNavProps> = ({
  isMobile,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
}) => {
  return (
    <div className={`sidebar ${!isMobile ? "open" : "closed"}`}>
      {/* {isMobile && (
        <div className="mobile-header">
          <div className="hamburger-button" onClick={toggleSidebar}>
            &#9776;
          </div>
          {isSidebarOpen && (
            <img
              src={NavBarLogoFinal}
              alt="Oxford Logo"
              className="sidebar-logo"
              onClick={() =>
                window.open("https://www.oxforddoc.com/", "_blank")
              }
            />
          )}
        </div>
      )} */}

      {isSidebarOpen && (
        <>
          {!isMobile && (
            <>
              <div className="sidebar-header">
                <img
                  src={NavBarLogoFinal}
                  alt="Oxford Logo"
                  className="sidebar-logo"
                  onClick={() =>
                    window.open("https://www.oxforddoc.com/", "_blank")
                  }
                />
              </div>
              <Nav className="flex-column">
                <Nav.Item className="mt-auto">
                  <div className="btn-contact">
                    <div>Contact Us: </div>
                    <a
                      href="tel:7639710124"
                      className="btn-contact-field"
                      style={{ textDecoration: "none" }}
                    >
                      (763) 971-0124 / (800) 801-9114
                    </a>
                    <a
                      href="mailto:request@oxforddoc.com"
                      className="btn-contact-field"
                    >
                      request@oxforddoc.com
                    </a>
                    <br></br>
                    <a href="/privacy-policy" className="btn-contact-field">
                      Privacy Policy
                    </a>
                  </div>
                </Nav.Item>
              </Nav>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ReferenceNav;
